export enum AUTH_TOKEN {
  ACCESS = 'access_token',
  REFRESH = 'refresh_token',
  CUSTOM = 'trend_custom_auth',
}

export const TOKEN_EXPIRATIONS: Record<AUTH_TOKEN, number> = {
  [AUTH_TOKEN.ACCESS]: 60 * 5, // 5 Minutes
  [AUTH_TOKEN.REFRESH]: 60 * 60 * 24 * 7, // 1 Week
  [AUTH_TOKEN.CUSTOM]: 60 * 5,
};
